var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper commissions-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('commission-projected', {
    on: {
      "onRepSelect": _vm.getAll
    }
  }), _vm._m(0), _c('b-tabs', {
    staticClass: "custom-tabs mt-3 commission-table-wrap",
    attrs: {
      "content-class": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Premium Commission"
    }
  }, [_c('div', {
    staticClass: "new-table-card prime-table "
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('h5', {}, [_vm._v("Premium Commissions")])]), _c('pagination', {
    staticClass: "mb-3",
    attrs: {
      "rows": _vm.rows
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  }), _c('simple-table', {
    attrs: {
      "columns": _vm.columns
    },
    scopedSlots: _vm._u([{
      key: "tableBody",
      fn: function fn() {
        return [_c('commission-table', {
          attrs: {
            "rows": _vm.rows
          },
          on: {
            "update:rows": function updateRows($event) {
              _vm.rows = $event;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c('pagination', {
    staticClass: "mb-3",
    attrs: {
      "rows": _vm.rows
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)]), _c('b-tab', {
    attrs: {
      "title": "Other Commissions"
    }
  }, [_c('div', {
    staticClass: "new-table-card"
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('h5', {}, [_vm._v("Other Commissions")])]), _c('pagination', {
    staticClass: "mb-3",
    attrs: {
      "rows": _vm.other_rows
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.other_rows = $event;
      }
    }
  }), _c('simple-table', {
    attrs: {
      "columns": _vm.othersColumns
    },
    scopedSlots: _vm._u([{
      key: "tableBody",
      fn: function fn() {
        return [_c('commission-other-table', {
          attrs: {
            "rows2": _vm.other_rows
          },
          on: {
            "update:rows2": function updateRows2($event) {
              _vm.other_rows = $event;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c('pagination', {
    staticClass: "mb-3",
    attrs: {
      "rows": _vm.other_rows
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.other_rows = $event;
      }
    }
  })], 1)])], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    staticClass: "pt-4"
  }, [_vm._v("Monthly Commission Report")])]);
}]

export { render, staticRenderFns }